import {
  Box,
  Button,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Typography,
} from "@mui/material";
import { Fragment } from "react";
import { useFormEditor } from "./FormEditorDataProvider";
import templateDefs from "./templateDefs";
import { TemplateBlockItem, TemplateGroup } from "./types";

export interface TemplatesProps {
  handleAddTemplate?: (block: TemplateBlockItem) => void;
  templates?: TemplateGroup[];
}
export default function Templates({
  handleAddTemplate: _handleAddTemplate,
  templates,
}: TemplatesProps) {
  const { handleAddTemplate, type } = useFormEditor();
  let totalSize = 0;
  return (
    <Grid
      container
      sx={{ flex: 0, minWidth: 220, maxWidth: 220, alignContent: "flex-start" }}
    >
      {(templates || templateDefs)
        .filter(t => (type === "file" ? t.name !== "Content" : true))
        .map((group, groupIndex) => {
          totalSize = 0;
          return (
            <Fragment key={groupIndex}>
              <Grid item xs={12} sx={{ paddingTop: 1, paddingBottom: 1 }}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontWeight: 500 }}
                >
                  {group.name}
                </Typography>
              </Grid>
              {group.templates?.map((template, index) => {
                const isLast = index === group.templates.length - 1;
                let size = template.name.length > 9 ? 2 : 1;
                const isEven = totalSize % 2 == 0;

                if (size === 1) {
                  let prevSize = 1;
                  if (
                    group.templates[index - 1] &&
                    group.templates[index - 1].name.length > 9
                  ) {
                    prevSize = 2;
                  }
                  let nextSize = 1;
                  if (
                    group.templates[index + 1] &&
                    group.templates[index + 1].name.length > 9
                  ) {
                    nextSize = 2;
                  }

                  //between two full width item
                  if (prevSize === 2 && nextSize === 2) {
                    size = 2;
                  }

                  //before a full width item at first column
                  if (isEven && nextSize === 2) {
                    size = 2;
                  }

                  //last item at first column
                  if (isEven && isLast) {
                    size = 2;
                  }
                }

                totalSize += size;

                return (
                  <Grid
                    item
                    xs={size === 2 ? 12 : 6}
                    key={template.name}
                    sx={{
                      borderRadius: 0,
                      padding: "1px",
                    }}
                  >
                    <Button
                      fullWidth
                      size="small"
                      onClick={() =>
                        _handleAddTemplate
                          ? _handleAddTemplate(template)
                          : handleAddTemplate(template)
                      }
                      variant="outlined"
                      sx={{
                        //borderRadius: 0,
                        justifyContent: "left",
                      }}
                      startIcon={
                        <span
                          className="material-icons"
                          style={{ fontSize: "1.2rem" }}
                        >
                          {template.icon}
                        </span>
                      }
                    >
                      {template.name}
                    </Button>
                  </Grid>
                );
              })}
            </Fragment>
          );
        })}
    </Grid>
  );
}
function TemplatesList() {
  const { handleAddTemplate } = useFormEditor();
  return (
    <Box>
      <List dense>
        {templateDefs?.map((group, groupIndex) => {
          return (
            <Fragment key={groupIndex}>
              <ListSubheader>{group.name}</ListSubheader>
              {group.templates?.map(template => {
                return (
                  <ListItemButton
                    key={template.name}
                    onClick={() => handleAddTemplate(template)}
                  >
                    <ListItemIcon sx={{ minWidth: 24 }}>
                      <span
                        className="material-icons"
                        style={{ fontSize: "1.2rem" }}
                      >
                        {template.icon}
                      </span>
                    </ListItemIcon>
                    <ListItemText primary={template.name} />
                  </ListItemButton>
                );
              })}
            </Fragment>
          );
        })}
      </List>
    </Box>
  );
}
